import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { confirmAlert } from "react-confirm-alert"; // Import
import { loadConnectAndInitialize } from '@stripe/connect-js';
import axios from 'axios';

import { API ,STRIPEPUBLICKEY,STRIPESECRETKEY} from '../../../backend';
import authHeader from '../../../services/auth-header';
import EditCompanyService from '../../../services/company/editCompanyService';
import GetCompanyInfoService from '../../../services/company/getCompanyInfoService';
import ButtonLoading from '../../../components/Loder/buttonLoading';

const StripeConnectButton = () => {
  const [loading, setLoading] = useState(false);
  const [screenloading, setScreenLoading] = useState(false);
  const [stripedata, setStripeData] = useState([]);
  const [stripecharges_enabled, setStripeCharges_enabled] = useState();
  const [stripedetails_submitted, setStripeDetails_submitted] = useState();
  const [stripeaccounid, setStripeAccountid] = useState('');
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString)
  const account_id = urlParams.get("account_id")
  const status = 'Complete'
  let navigate = useNavigate()

  const getcompanydata = () => {
    setScreenLoading(true)
    GetCompanyInfoService.getCompanyInfo().then(
      (response) => {
        setStripeAccountid(response.data.stripeaccount)
        setScreenLoading(false)
      })
  }

  useEffect(() => {
    getcompanydata()
  }, [])

  const stripereterive = () => {
    setScreenLoading(true)

    const response = axios.get(API + `paymentsub/api/retrieve-stripe/?stripeid=${stripeaccounid}`, {
      // method: 'POST',
      headers: authHeader()
    }).then((response) => {
      if (response.data.success === 1) {

        setStripeData(response.data.stripe_account)
        setStripeCharges_enabled(response.data.stripe_account.charges_enabled)
        setStripeDetails_submitted(response.data.stripe_account.details_submitted)
        setScreenLoading(false)

      }
      else {
        setScreenLoading(false)

      }
    })

  }

  useEffect(() => {
    if (stripeaccounid !== '') {

      stripereterive()
    }
  }, [stripeaccounid])

  useEffect(() => {
    if (account_id !== '' && account_id !== null) {
      EditCompanyService.editCompanystripeaccount(
        account_id,
        status
      ).then(
        (response) => {
          if (response.data.success) {
            setLoading(false)
            setTimeout(() => {
              getcompanydata()
              navigate("/paymentstripe")
            }, 2000)
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          }
          else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            setLoading(false)
          }
        },
      )
    }
  }, [account_id])

  const handleStripeIntegration = async () => {
    setLoading(true);

    try {
      const response = await fetch(API + 'paymentsub/api/create-stripe-account-and-link/', {
        headers: authHeader()
      });

      if (response.ok) {
        const data = await response.json();
        if (data.account_link_url) {
          window.location.href = data.account_link_url; // Redirect to Stripe
        } else {
          console.error('Error creating Stripe account link.');
        }
      } else {
        console.error('Error creating Stripe account and link.');
      }
    } catch (error) {
      setLoading(false);

      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (stripeaccounid !== '') {
      const fetchClientSecret = async () => {
        try {
          // Fetch the AccountSession client secret
          const response = await fetch(API + `paymentsub/api/account_session/?account_id=${stripeaccounid}`, { method: "POST" });

          if (!response.ok) {
            // Handle errors on the client side here
            const { error } = await response.json();
            return undefined;
          } else {
            const { client_secret: clientSecret } = await response.json();
            return clientSecret;
          }
        } catch (error) {
          console.error('An error occurred while fetching client secret: ', error);
          return undefined;
        }
      };

      const initializeStripeConnect = async () => {
        try {
          const secret = await fetchClientSecret();

          if (secret) {
            const instance = loadConnectAndInitialize({
              // This is your test publishable API key.
              publishableKey: STRIPEPUBLICKEY,
              // publishableKey: "pk_test_51NtSnlLKpVRgqWxom6iTaBorBjLi2pN6xJZIsOOwHcnwrEPGUZZdX0DlPrtyvsCrXyfAWkjvo4ApMNles7mwWvrD00lXbFgo1d",
              fetchClientSecret: fetchClientSecret,
              appearance: {
                overlays: 'dialog',
                variables: {
                  colorPrimary: '#625afa',
                },
              },
            });

            setStripeConnectInstance(instance);
          }
        } catch (error) {
          console.error('An error occurred while initializing Stripe Connect: ', error);
        }
      };

      initializeStripeConnect();
    }
  }, [stripeaccounid]);

  const handleclick = () => {
    window.location.replace("https://dashboard.stripe.com/login")
  };
const [stripeaccount, setstripeaccount] = useState('')

const handleDeleteStripe = () => {
  confirmAlert({
    title: "",
    message: "Are you sure you want to delete your stripe account?.",
    buttons: [
      {
        label: "Yes",
        onClick: () => {
          handleclickStripe()
        },
      },
      {
        label: "No",
      },
    ],
  });
};

  const handleclickStripe = () =>{
    EditCompanyService.editStirpeCompany(
     stripeaccount
    ).then(
      (response) => {
        if (response.data.success) {
          setLoading(false)
          toast.success(`Removed stripe account successfully`,{
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",})
            setTimeout(()=>{

              getcompanydata()
              setStripeCharges_enabled()
              setStripeDetails_submitted()
            },1000)
        }
        else {
          toast.error(`${response.data.error}`,{
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",})
          setLoading(false)
        }
      },
    )
  }
  return (
    screenloading === true ?
      <div className='container-fluid mt-12 mb-10 text-center ' >

        <ButtonLoading color='#21A5FE' />
      </div>
      :
      stripecharges_enabled === true ?
        <div className='container-fluid pt-5 mt-12  mb-10'>
        <div className=" text-center"><h3>To change your business information / bank details, <span className="hyperlink" onClick={()=>handleclick()}>click here</span></h3></div><br/><br/>
        <div className="text-center"><h5>Romove stripe your account please click here. <span className="hyperlink" onClick={()=>handleDeleteStripe()}>click here</span></h5></div>
        </div>
        
        :
        stripedetails_submitted === true ? <span className='container-fluid text-center'><h2 className='text-center mt-12'>Your account will become active soon.</h2><p className='mb-10 '><h4>Please check your email for verification.</h4></p></span>
          :

          <div className='container-fluid pt-5 mt-12 text-center mb-10'>
            <button className='btn btn-primary' onClick={handleStripeIntegration} disabled={loading}>
              {loading ? 'Creating Stripe Account and Link...' : 'Create Stripe Account '}
            </button>
          </div>
  );
};

export default StripeConnectButton;
